import React from 'react';

const Header = ({title,tag:Tag = "h2"}) =>{
    return(
        <div className="section_header">
        <Tag>
            {title}
        </Tag>
        </div>
    );
}

export default Header;